import { MuiStylesType } from 'model/muiStyles.model';
import zeplinColor from 'theme/Color';

export const muiStyles: MuiStylesType = {
  root: { borderRadius: '14px', boxShadow: 'rgba(0, 0, 0, 0.15)' },
  actions: {
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
    padding: '12px 0',
  },
  action: {
    padding: '4px 16px',
    display: 'flex',
    alignItems: 'center',
    gap: '9px',
    cursor: 'pointer',
    backgroundColor: 'transparent',
    border: 'none',
    margin: 0,
    ':hover': {
      backgroundColor: zeplinColor.Neutral3,
    },
  },
};
